export default __webpack_public_path__ + "9241aa25a49981c5e17c37683c2b45cf.png";